export const USER_STORAGE_KEY = 'user'
export const ACCESS_TOKEN_KEY = 'accessToken'
